import { AxiosInstance } from 'axios';
import { apiRequest } from './apiRequest';
import { ApiResponse } from './types';

export interface ConfirmAppointmentRequest {
  customer_id: string;
  provider_id: string;
  service_ids: string[];
  datetime: string;
}

export interface ConfirmAppointmentResponse {
  isReserved: boolean;
}

export type ConfirmAppointment = (
  data: ConfirmAppointmentRequest
) => Promise<ApiResponse<ConfirmAppointmentResponse>>;

const confirmAppointment = (api: AxiosInstance): ConfirmAppointment => {
  return async (data: ConfirmAppointmentRequest): Promise<ApiResponse<ConfirmAppointmentResponse>> => {
    return apiRequest<ConfirmAppointmentResponse>(api, {
      method: 'POST',
      url: `/api/custom-booking/book-service`,
      data: data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  };
};

export default confirmAppointment;